/* BillPill — "JETZT KAUFEN"-CTA: smooth-scroll zum Kaufbereich.
   Der CTA-Link traegt den Hash #jetzt-kaufen. Auf der PDP wird damit
   zur Ticker-Section direkt ueber dem Kaufbereich gescrollt; von anderen
   Seiten navigiert der Link normal zur PDP und scrollt dort nach dem Laden. */
(function () {
  'use strict';

  var HASH = '#jetzt-kaufen';
  var TARGET = '.ticker-banner';

  function target() {
    return document.querySelector(TARGET);
  }

  function stickyHeaderHeight() {
    var els = document.querySelectorAll(
      '.section-header, .shopify-section-header, .header-wrapper, header'
    );
    var h = 0, i, cs, rect;
    for (i = 0; i < els.length; i++) {
      cs = window.getComputedStyle(els[i]);
      if (cs.position === 'fixed' || cs.position === 'sticky') {
        rect = els[i].getBoundingClientRect().height;
        if (rect > h) h = rect;
      }
    }
    return h;
  }

  function scrollToTarget() {
    var el = target();
    if (!el) return false;
    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var top = el.getBoundingClientRect().top + y - stickyHeaderHeight();
    if (top < 0) top = 0;
    try {
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    } catch (e) {
      window.scrollTo(0, top);
    }
    return true;
  }

  function clearHash() {
    if (window.history && window.history.replaceState) {
      try {
        window.history.replaceState(
          null, document.title,
          window.location.pathname + window.location.search
        );
      } catch (e) {}
    }
  }

  /* 1) Klick auf einen Link mit #jetzt-kaufen */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var a = t.closest('a[href]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf(HASH) === -1) return;
    var url;
    try { url = new URL(a.href, window.location.href); }
    catch (e) { return; }
    /* Ziel == aktuelle Seite -> selbst smooth scrollen.
       Andere Seite -> Browser navigieren lassen (Load-Handler greift dort). */
    if (url.pathname === window.location.pathname && target()) {
      ev.preventDefault();
      scrollToTarget();
    }
  }, false);

  /* 2) Ankunft auf einer Seite mit #jetzt-kaufen (Navigation von woanders) */
  function onArrive() {
    if (window.location.hash !== HASH) return;
    var tries = 0;
    (function attempt() {
      if (!scrollToTarget() && tries++ < 25) {
        setTimeout(attempt, 150);
      }
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onArrive, false);
  } else {
    onArrive();
  }

  /* nach vollem Laden (Bilder/Apps) Position final korrigieren + Hash aufraeumen */
  window.addEventListener('load', function () {
    if (window.location.hash !== HASH) return;
    setTimeout(function () {
      scrollToTarget();
      clearHash();
    }, 350);
  }, false);

})();
